// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1xF4Q","upload":"Small_upload__1JJPv","imageWrap":"Small_imageWrap__2KJyk","removeBtn":"Small_removeBtn__1tHTG"};